<script lang="ts">
	import Logo from "../../assets/icons/LuxedoLogo.svg"
	import SidebarLinks from "./Sidebar_Links.svelte"
	import { showContentSuggestions } from "luxedo-comps"
	import { ReleaseNotes } from "../../release-notes"
	import { AccountNavigator } from "./account/AccountStore"
	import { openWhatsNewOverlay } from "../reusable/overlays/whats-new"

	interface Props {
		children?: import("svelte").Snippet
	}

	let { children }: Props = $props()

	const version = Object.keys(ReleaseNotes)[0]

	function openAccountOverlay(e: MouseEvent) {
		e.preventDefault()
		AccountNavigator.open()
	}
</script>

<div id="page-base">
	<header id="page-header">
		<div class="flex-column">
			<a
				id="error-report-link"
				target="_blank"
				href="https://luxhome.ai/pages/help?hcUrl=%2Fen-US%2Fcontact">Report Issue</a
			>
		</div>
		<a id="account-button" onclick={openAccountOverlay} href="#">Account</a>
	</header>
	<div id="sidebar-container">
		<div id="sidebar-top">
			<img id="luxedo-logo" src={Logo} alt="Luxedo Logo" />
			<SidebarLinks />
		</div>
		<!-- <div class="nav-links"> -->
		<div id="help-and-info">
			<a id="help-link" href="https://luxhome.ai/pages/help" target="_blank">
				<button id="help-link-button" class="link-button"> Help Desk </button>
			</a>
			<button id="content-solutions" class="link-button" onclick={showContentSuggestions}>
				Content Solutions
			</button>
			<button id="whats-new-button" class="link-button" onclick={() => openWhatsNewOverlay()}>
				What's New (
				<span class="version-number">
					{version}
				</span>)
			</button>
		</div>

		<!-- </div> -->
	</div>
	<main>
		{@render children?.()}
	</main>
</div>

<style>
	#page-base {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-template-rows: auto 1fr;
		height: 100%;
		width: 100dvw;
		overflow: hidden;

		--nav-padding: 2rem;
	}

	#sidebar-top {
		display: flex;
		flex-direction: column;
		align-items: center;
		overflow: hidden;
	}

	#luxedo-logo {
		margin-top: var(--nav-padding);
		width: 10rem;
	}

	#page-header {
		background-color: var(--color-bg);
		padding: 1rem 2rem 1rem 0;
		height: var(--header-height);
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
	}

	#account-button {
		line-height: 2rem;
		font-size: var(--h1);
		color: var(--color-main);
	}

	#help-link,
	#error-report-link,
	#error-report-link {
		margin-right: 1rem;
	}

	#error-report-link:hover,
	#error-report-link:focus-visible,
	#sidebar-container {
		grid-row: 1 / span 2;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}

	#help-and-info {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 2rem;
	}

	#help-link {
		color: var(--color-text-light);
		border: none;
	}

	#whats-new-button {
		padding: 0;
		padding-bottom: 0.5rem;
		margin-right: 1rem;
	}

	#content-solutions,
	#help-link-button {
		padding: 0;
		margin-right: 1rem;
	}

	main {
		background-color: var(--color-bg);
		padding: 0 1rem;
		overflow: hidden;
	}

	.version-number {
		font-size: var(--h3);
		color: var(--color-main);
	}

	:global(.no-padding) {
		padding: 0;
	}

	:global(.overlay.whats-new) {
		height: 80vh;
	}
</style>
